import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { loginDealer } from "api/services/dealer";
import { getDealerPortalPath, Paths } from "router/Paths";
import Images from "images/Images";
import {
  dealerPortalCopy,
  DealerPortalLanguage,
  getSavedDealerLanguage,
  saveDealerLanguage,
} from "copy/dealerPortalCopy";

function DealerLoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [language, setLanguage] = useState<DealerPortalLanguage>(
    getSavedDealerLanguage()
  );
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const copy = dealerPortalCopy[language];

  const toggleLanguage = () => {
    const nextLanguage = language === "en" ? "am" : "en";
    setLanguage(nextLanguage);
    saveDealerLanguage(nextLanguage);
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError("");
    try {
      setLoading(true);
      const response = await loginDealer({ phoneNumber, password });
      localStorage.setItem("dealerToken", response.token);
      localStorage.setItem("dealer", JSON.stringify(response.dealer));
      const next = new URLSearchParams(location.search).get("next");
      navigate(next || getDealerPortalPath(Paths.dealerInventory));
    } catch (error: any) {
      setError(error?.response?.data?.msg || copy.loginError);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className={ClassName.page}>
      <form className={ClassName.card} onSubmit={handleSubmit}>
        <button
          className={ClassName.languageButton}
          type="button"
          onClick={toggleLanguage}
        >
          {copy.languageToggle}
        </button>
        <img src={Images.logo} alt="BossCar" className={ClassName.logo} />
        <h1 className={ClassName.title}>{copy.loginTitle}</h1>
        <p className={ClassName.description}>
          {copy.loginDescription}
        </p>
        <input
          className={ClassName.input}
          placeholder={copy.phone}
          value={phoneNumber}
          onChange={(event) => setPhoneNumber(event.target.value)}
        />
        <input
          className={ClassName.input}
          placeholder={copy.password}
          type="password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
        />
        {error && <span className={ClassName.error}>{error}</span>}
        <button className={ClassName.button} disabled={loading}>
          {loading ? copy.signingIn : copy.signIn}
        </button>
      </form>
    </main>
  );
}

const ClassName = {
  page: "min-h-screen w-screen bg-[#f4f1e6] flex items-center justify-center p-4",
  card: "w-full max-w-md bg-white rounded-3xl shadow-primaryShadow p-6 flex flex-col gap-4",
  languageButton:
    "self-end rounded-xl bg-bgSecondary px-3 py-2 text-sm font-semibold text-primaryText",
  logo: "w-28 object-contain",
  title: "text-2xl font-semibold text-primaryText",
  description: "text-sm text-secondaryText leading-6",
  input:
    "h-12 rounded-2xl border border-borderPrimary px-4 text-base font-normal outline-none placeholder:font-normal focus:border-primary",
  error: "text-sm text-primary",
  button:
    "h-12 rounded-2xl bg-primary text-white font-semibold disabled:opacity-60",
};

export default DealerLoginPage;
